// import './style.css'
import SkipNextOutlinedIcon from "@mui/icons-material/SkipNextOutlined";
import SkipPreviousOutlinedIcon from "@mui/icons-material/SkipPreviousOutlined";
import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import style from "./history.module.scss";
import { useTranslation } from "react-i18next";
//import {CustumBtnGroup} from '../common';
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";
const ViewDetailsModal = (props) => {
  console.log("propsmodal", props);
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();

  return (
    <Modal
      show={props.show}
      // dialogClassName="modal-fullscreen"
      onHide={props.handleClose}
      contentClassName={`${
        currentTheme == "theme-dark"
          ? `${style.dark_mode_modalContent}`
          : `${style.modalContent}`
      }`}
    >
      <Modal.Header
        closeButton
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_modalHeader}`
            : `${style.modalHeader}`
        }`}
      ></Modal.Header>
      <Modal.Body
        style={{ background: currentTheme === "theme-dark" ? "" : "#fff" }}
      >
        <div className={`${style.invoiceBody}`}>
          <div className={`${style.printButton}`}>
            <div style={{ display: "none" }}></div>
          </div>
          <Table
            class="table-striped"
            responsive
            borderless
            width="100%"
            height="100"
          >
            <div>
              <h2 style={{ fontWeight: "bold", padding: "1rem" }}>
                {" "}
                4P Generation History
              </h2>
            </div>
            <tbody>
              <tr>
                <td style={{ borderRight: "1px solid #ccc" }} colSpan="2">
                  <TableContainer style={{ marginTop: 12 }}>
                    <Table style={{ border: "none" }}>
                      <TableHead style={{ backgroundColor: "green" }}>
                        <TableRow>
                          <TableCell>
                            <b style={{ color: "white" }}>
                              {" "}
                              {t("Common.activationcode")}
                            </b>
                          </TableCell>
                          <TableCell>
                            <b style={{ color: "white" }}>
                              {t("Common.securitycode")}
                            </b>
                          </TableCell>
                          <TableCell>
                            <b style={{ color: "white" }}>
                              {t("Common.productName")}
                            </b>
                          </TableCell>
                          <TableCell>
                            <b style={{ color: "white" }}>4P PV</b>
                          </TableCell>
                          <TableCell>
                            <b style={{ color: "white" }}>
                              {t("Common.status")}
                            </b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.data.map((item, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell>{item.access_code}</TableCell>
                              <TableCell>{item.security_code}</TableCell>
                              <TableCell>{item.name}</TableCell>
                              <TableCell>{item.pv}</TableCell>
                              <TableCell>{item.status}</TableCell>
                            </TableRow>
                          );
                        })}
                        {/* {props?.data?.data?.codeResult &&
                          props?.data.data?.codeResult.map((product, index) => (
                            <TableRow key={index}>
                              <TableCell>{product.product}</TableCell>
                              <TableCell>{product.access_code}</TableCell>
                              <TableCell>{product.security_code}</TableCell>
                              <TableCell>{product.status}</TableCell>
                              <TableCell>{product.quantity}</TableCell>
                              <TableCell>{product.unit_price}</TableCell>
                              <TableCell>{product.amount}</TableCell>
                            </TableRow>
                          ))} */}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <br />
                </td>
              </tr>
            </tbody>
          </Table>
          {/* </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={props.handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewDetailsModal;
